const GetBticinoInHome = (token, data, cb) => {
  fetch(`${process.env.REACT_APP_API}/admin/api/bticino?house_number=${data}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((json) => cb(null, json))
    .catch((err) => cb(err, null));
};

export default GetBticinoInHome;